import { ColorsEnum } from 'app.types';

export const getRgbColor = (
  colorBackground: ColorsEnum,
  opacity: number,
  isDark?: boolean,
): string => {
  if (isDark) {
    return `rgba(7, 12, 43, ${opacity})`; // --dark-blue-background
  }

  switch (colorBackground) {
    case ColorsEnum.blue:
      return `rgba(52, 137, 243, ${opacity})`; // --light-blue-100

    case ColorsEnum.purple:
      return `rgba(148, 141, 229, ${opacity})`; // --light-purple-100

    case ColorsEnum.lilac:
      return `rgba(207, 135, 221, ${opacity})`; // --light-lilac-100

    case ColorsEnum.marine:
      return `rgba(84, 190, 204, ${opacity})`; // --light-marine-100

    default:
      return `rgba(7, 12, 43, ${opacity})`;
  }
};
